import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import {
  Button,
  Stack,
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  TextField,
  Typography,
  Divider,
  List,
  ListItemText,
  ListItem,
  Checkbox,
  DialogContent,
} from "@mui/material";

import MailComposeFeilds from "./MailComposeFeilds";
import FrequencyDialog from "./FrequencyDialog";
import { getSubUserListByUserId } from "../API/nimbleAPI";
import {
  CustomTitle,
  Loader,
  getYesterdayDate,
} from "../HelperFunctions/HelperFunctions";
import { enqueueSnackbar } from "notistack";
import { useLoaderData } from "react-router-dom";

const MailCompose = ({ slide, setSlide, onClose }) => {
  const { token, clientID } = useLoaderData()
  const { values, setFieldValue, handleChange, resetForm } = useFormikContext();

  const buildSubject = (reportBookName) => {
    const day = new Date(getYesterdayDate());
    const longDate = day.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
      timeZone: "UTC",
    });
    const book = (reportBookName || "").trim() || "Scheduled Reports";
    return `${book} ${longDate}`;
  };

  const handleReportBookNameChange = (e) => {
    handleChange(e);
    setFieldValue("mail_compose.subject", buildSubject(e.target.value));
  };
  // console.log("MailCompose", values)
  const [frequencyDialogOpen, setFrequencyDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);

      // "name": f"{user_data.get('FirstName')}, {user_data.get('LastName')}",
      // "email": email,
      // "role": user_data.get("Role"),
      const selectedCorps = values.selected_corporations;
      const userCorporations = await getSubUserListByUserId();

      let users = [];

      Object.entries(userCorporations).forEach(([email, value]) => {
        const userCorpIds = value["Corporations"].map(
          (c) => c["CorporationID"]
        );

        if (
          // userCorpIds.length === selectedCorps.length &&
          selectedCorps.every((id) => userCorpIds.includes(id))
        ) {
          users.push({
            email,
            name: `${value["FirstName"]} ${value["LastName"]}`,
            role: value["Role"],
            user_id: value["User_Id"]
          });
        }
      });

      setAllUsers(users);
      const uniqueRoles = [...new Set(users.map((user) => user.role))];
      setRoles(uniqueRoles);
    } catch (error) {
      enqueueSnackbar("Error while getting user details", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const filteredUsers =
    values.roles === "all"
      ? allUsers
      : allUsers.filter((user) => user.role === values.roles);

  const handleCheckboxChange = (userInfo) => {

    const email = userInfo.email;

    const selectedUsers = values.users || [];
    const selectedUsersInfo = values.users_info || [];

    let updatedUsers, updatedUsersInfo;

    if (selectedUsers.includes(email)) {
      updatedUsers = selectedUsers.filter((e) => e !== email);
      updatedUsersInfo = selectedUsersInfo.filter(
        (user) => user.email !== email
      );
    } else {
      updatedUsers = [...selectedUsers, email];
      updatedUsersInfo = [...selectedUsersInfo, userInfo];
    }

    setFieldValue("users", updatedUsers);
    setFieldValue('mail_compose.to', updatedUsers);
    setFieldValue("users_info", updatedUsersInfo);
  };

  return (
    <>
      <DialogContent sx={{ p: 0 }}>
        <Box p={1} bgcolor={"white"}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={1}
          >
            <Stack gap={2} direction={"row"}>
              <TextField
                sx={{ minWidth: 200 }}
                // size="small"
                label="Report Book Name"
                variant="standard"
                name="reportBookName"
                value={values.reportBookName}
                onChange={handleReportBookNameChange}
              />

              <FormControl sx={{ minWidth: 150, maxWidth: 280, m: 1, ml: 20 }}>
                <InputLabel id="bulk-action-label">Report Book Type</InputLabel>
                <Select
                  size="small"
                  label="Report Book Type"
                  name="reviewReportBookType"
                  value={values.reviewReportBookType}
                  onChange={handleChange}
                  inputProps={{ readOnly: true }}
                >
                  {/* <MenuItem value="periodic_reports">Periodic Reports</MenuItem> */}
                  <MenuItem value="custom_reports">Custom Reports</MenuItem>
                </Select>
              </FormControl>

              <TextField
                sx={{
                  mt: 1,
                  minWidth: 220,
                  backgroundColor: "transparent",

                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "transparent",
                    maxHeight: "33px",
                    fontSize: "13px",
                    bgcolor: "#f5f5f5",
                    fontWeight: 500,
                  },
                }}
                size="small"
                label="Corporation"
                // variant="standard"
                name="corporation"
                value={
                  values.selected_corporations.length === values.cropCount && values.cropCount > 0 ? "All_corporation(s)selected"
                    :
                    values.selected_corporations.length > 9
                      ? `${values.selected_corporations.length}_corporation(s)selected`
                      : values.selected_corporations.length > 0
                        ? `0${values.selected_corporations.length}_corporation(s)selected`
                        : "00_corporation(s)selected"
                }
                InputProps={{ readOnly: true }}
              />
            </Stack>
            <Box>
              <Stack direction={"row"} gap={3}>
                <Button
                  variant="contained"
                  size="small"
                  disableElevation
                  disableRipple
                  sx={{
                    px: 4,
                    textTransform: "none",
                    backgroundColor: "#b5dcf2",
                    color: "#000",
                    fontWeight: 400,
                  }}
                  // onClick={onClose}
                  onClick={() => {
                    setSlide(slide - 2);
                    resetForm();
                    onClose();
                  }}
                >
                  Close
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  disableElevation
                  disableRipple
                  sx={{
                    px: 3,
                    textTransform: "none",
                    backgroundColor: "#b5dcf2",
                    color: "#000",
                    fontWeight: 400,
                  }}
                  onClick={() => setSlide(slide - 1)}
                // type="submit"
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  disableElevation
                  disableRipple
                  sx={{
                    // px: 3,
                    textTransform: "none",
                    backgroundColor: "#b5dcf2",
                    color: "#000",
                    fontWeight: 400,
                    minWidth: "100px",
                  }}
                  // onClick={() => setSlide(slide + 1)}
                  onClick={() => {
                    if (!values.users || values.users.length === 0) {
                      enqueueSnackbar("Please select at least one user", { variant: "info" });
                      return;
                    }
                    setFrequencyDialogOpen(true);
                  }}
                >
                  Save & Next
                </Button>
              </Stack>
            </Box>
          </Stack>
          <Stack direction={"row"} height={"570px"} mt={1} gap={0.5}>
            <Stack
              width={"23%"}
              border={"1px solid #d7d7d7"}
              borderRadius={1}
              direction={"column"}
              bgcolor={"#f2f2f2"}
              minWidth={"300px"}
            >
              <Stack
                bgcolor={"#aaaaaa"}
                alignItems={"center"}
                justifyContent={"center"}
                padding={1}
              >
                <Typography
                  fontSize={"12.5px"}
                  fontWeight={700}
                  color="#ffffff"
                >
                  Mail Compose
                </Typography>
              </Stack>
              <Stack
                p={1}
                direction={"row"}
                alignContent={"center"}
                justifyContent={"space-between"}
              >
                <Typography fontSize={"13px"} fontWeight={500}>
                  Users
                </Typography>

                <Stack direction={"row"} gap={1}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      mt: 0.5,
                    }}
                  >
                    Role
                  </Typography>

                  <Select
                    size="small"
                    name="roles"
                    value={values.roles}
                    onChange={handleChange}
                    style={{ width: "100px", height: "23px", fontSize: "11px" }}
                  >
                    <MenuItem value="all">All</MenuItem>
                    {roles.map((role, index) => (
                      <MenuItem key={index} value={role}>
                        {CustomTitle(role)}
                      </MenuItem>
                    ))}
                  </Select>
                </Stack>
              </Stack>

              <Stack padding={0.5} overflow={"auto"}>
                {filteredUsers.length !== 0 ? (
                  <List sx={{ bgcolor: "background.paper" }}>
                    {filteredUsers.map((role, index) => (
                      <React.Fragment key={role.email || index}>
                        <ListItem
                          key={index}
                          alignItems="flex-start"
                          disablePadding
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "start",
                          }}
                        >
                          <Stack direction="row" alignItems="center">
                            <Checkbox
                              sx={{ fontSize: "5px" }}
                              size="small"
                              disableRipple
                              color="grey"
                              checked={values.users.includes(role.email)}
                              onChange={() => handleCheckboxChange(role)}
                            />
                            <ListItemText
                              primary={
                                <Stack direction={"column"}>
                                  <Typography
                                    sx={{ fontWeight: 300 }}
                                    fontSize={"10px"}
                                  >
                                    {role.role || "none"}
                                  </Typography>
                                  <Typography
                                    sx={{ fontWeight: 400 }}
                                    fontSize={"12px"}
                                  >
                                    {role.name}
                                  </Typography>
                                </Stack>
                              }
                              secondary={
                                <Typography
                                  sx={{ fontWeight: 300 }}
                                  fontSize={"10px"}
                                >
                                  {role.email}
                                </Typography>
                              }
                            />
                          </Stack>
                        </ListItem>
                        {index < filteredUsers.length - 1 && <Divider />}
                      </React.Fragment>
                    ))}
                  </List>
                ) : (
                  <Stack
                    // justifyItems={"center"}
                    alignItems={"center"}
                  >
                    <Typography>no users found</Typography>
                  </Stack>
                )}
              </Stack>
            </Stack>

            <Stack
              width={"77%"}
              border={"1px solid #d7d7d7"}
              borderRadius={1}
              direction={"column"}
              padding={1}
              gap={1}
              minWidth={"920px"}
            >
              <MailComposeFeilds />
            </Stack>
          </Stack>
          <FrequencyDialog
            open={frequencyDialogOpen}
            onClose={() => setFrequencyDialogOpen(false)}
          />
        </Box>
      </DialogContent>
      <Loader loading={loading} />
    </>
  );
};

export default MailCompose;
